import React from 'react';
import PropTypes from 'prop-types';
import questionHelperService from '../../services/questionView/QuestionHelperServices';
import utilService from '../../services/UtilService';
import AdditionalResource from './AdditionalResource';
import constants from '../../qti/Constants';
import { generateFileUrlForLogicalName } from '../../qti/parser/question/MediaModels';
import sessionReader from '../../store/readHelpers/SessionReader';

class FileAdditionalResource extends React.PureComponent {
    static propTypes = {
        resource: PropTypes.object.isRequired,
    };

    render() {
        const { resource } = this.props;
        const { title, contentItemId, logicalName } = resource;
        const pdfJsService = questionHelperService.getServices().pdfJsService;
        const fileCiUrl = utilService.generateUrlForContentItemId(contentItemId, 'pdf', true);

        if (window.offlineMode) {
            const offlineUrl = pdfJsService.getOfflinePdfJsUrl(contentItemId);
            return <AdditionalResource url={offlineUrl} title={title} type={constants.additionalResourceType.FILE} />;
        }

        // Build the servlet URL that matches the cache key used during cacheQuestionSetMedia.
        // This is the URL the service worker has cached the PDF under, which differs from
        // the fileCiUrl used in online mode (different endpoint: /file/cil/ vs /file/ci/).
        const assessmentRunId = sessionReader.getAssessmentRunId();
        const cachedServletUrl = logicalName
            ? generateFileUrlForLogicalName(logicalName, '', assessmentRunId, constants.additionalResourceType.FILE)
            : undefined;

        return (
            <AdditionalResource
                url={fileCiUrl}
                title={title}
                type={constants.additionalResourceType.FILE}
                cachedServletUrl={cachedServletUrl}
                presignedUrl={resource.mediaInfo?.presignedURL}
            />
        );
    }
}

export default FileAdditionalResource;
